import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

const OrderPreview = ({ orderPreview }) => {
  const { priceInfo } = orderPreview;
  const priceListItems = priceInfo.priceListItems || [];
  return (
    <ul className="payment-detail list-unstyled">
      {priceListItems.map((priceItem, idx) => (
        <li key={`payment-detail-${idx}`} className="detail-item">
          <h4 className={cx("detail-item-price", { "text-orange": priceItem.isRed })}>
            {!priceItem.reduced || <del>{priceItem.originMoney}</del>}
            {priceItem.money}
          </h4>
          <h4 className={cx("title", { "text-orange": priceItem.isRed })}>
            {priceItem.title}
            {!priceItem.reduced || <span className="detail-item-price-reduce-desc">{priceItem.reduceDesc}</span>}
          </h4>
          {priceItem.subtitle ? <h6>{priceItem.subtitle}</h6> : ""}
        </li>
      ))}
      <li key={`payment-detail-00`} className="detail-item">
        <hr />
        <h4 className="detail-item-price text-orange">￥{priceInfo.userMoney / 100}</h4>
        <h4 className="title">总价</h4>
      </li>
    </ul>
  );
};

OrderPreview.propTypes = {
  orderPreview: PropTypes.shape({
    priceInfo: PropTypes.shape({
      userMoney: PropTypes.number.isRequired,
      priceListItems: PropTypes.array,
    }).isRequired,
  }).isRequired,
};

export default OrderPreview;

require("./index.less");